import Repository from '@/api/Repository'

const resource = '/'

export default {

  info() {
    return Repository.get(`${resource}info`)
  },

}
